import { createSlice } from '@reduxjs/toolkit';
import { handleGetMasterData } from './masterThunk';
import { IMasterData } from '~/utils/interface/master';
import { cast } from '~/utils/helper';

export interface MasterState extends IMasterData {}

const initialState: MasterState = {
  jobTypes: [],
  jobCostTypes: [],
  jobCategories: [],
  jobCostSubTypes: [],
  jobProperties: [],
  addtionalContactAdjusters: [],
  addtionalContactTypes: [],
  eventColors: [],
  referralSources: [],
  crmCategories: [],
  crmStatuses: [],
  customerStatuses: [],
  prices: [],
  jobStatuses: [],
  jobStatusCodes: [],
  sourceOfLosses: [],
  waterCategory: [],
  waterClass: [],

  equipments: [],
  materialTypes: [],
  accessCode: [],
  hazard: [],
  customerType: [],
  testing: [],
  ppeUsed: [],
  debrisDisposal: [],
  billing: [],
};

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetMasterData.fulfilled, (state, action) => {
      if (action.payload.jobTypes) state.jobTypes = action.payload.jobTypes;
      if (action.payload.jobCostTypes) state.jobCostTypes = action.payload.jobCostTypes;
      if (action.payload.jobCategories) state.jobCategories = action.payload.jobCategories;
      if (action.payload.materialTypes) state.materialTypes = action.payload.materialTypes;
      if (action.payload.jobCostSubTypes) state.jobCostSubTypes = action.payload.jobCostSubTypes;
      if (action.payload.addtionalContactAdjusters) {
        state.addtionalContactAdjusters = action.payload.addtionalContactAdjusters.map((item) => ({
          id: cast(item),
          name: cast(item),
        }));
      }
      if (action.payload.addtionalContactTypes) {
        state.addtionalContactTypes = action.payload.addtionalContactTypes.map((item) => ({
          id: cast(item),
          name: cast(item),
        }));
      }
      if (action.payload.customers) state.customers = action.payload.customers;
      if (action.payload.allCustomers) state.allCustomers = action.payload.allCustomers;
      if (action.payload.eventColors) state.eventColors = action.payload.eventColors;
      if (action.payload.units) state.units = action.payload.units;
      if (action.payload.customerTypes) state.customerTypes = action.payload.customerTypes;
      if (action.payload.customerStatuses) state.customerStatuses = action.payload.customerStatuses;
      if (action.payload.customerRelationshipTypes) {
        state.customerRelationshipTypes = action.payload.customerRelationshipTypes;
      }
      if (action.payload.jobProperties) state.jobProperties = action.payload.jobProperties;
      if (action.payload.referralSources) state.referralSources = action.payload.referralSources;
      if (action.payload.crmCategories) state.crmCategories = action.payload.crmCategories;
      if (action.payload.crmStatuses) state.crmStatuses = action.payload.crmStatuses;
      if (action.payload.customerStatuses) state.customerStatuses = action.payload.customerStatuses;
      if (action.payload.prices) state.prices = action.payload.prices;
      if (action.payload.jobStatuses) state.jobStatuses = action.payload.jobStatuses;
      if (action.payload.jobStatusCodes) state.jobStatusCodes = action.payload.jobStatusCodes;
      if (action.payload.sourceOfLosses) state.sourceOfLosses = action.payload.sourceOfLosses;
      if (action.payload.waterCategory) state.waterCategory = action.payload.waterCategory;
      if (action.payload.waterClass) state.waterClass = action.payload.waterClass;
      if (action.payload.accessCode) state.accessCode = action.payload.accessCode;
      if (action.payload.hazard) state.hazard = action.payload.hazard;
      if (action.payload.customerType) state.customerType = action.payload.customerType;
      if (action.payload.testing) state.testing = action.payload.testing;
      if (action.payload.ppeUsed) state.ppeUsed = action.payload.ppeUsed;
      if (action.payload.debrisDisposal) state.debrisDisposal = action.payload.debrisDisposal;
      if (action.payload.billing) state.billing = action.payload.billing;
      if (action.payload.equipments) state.equipments = action.payload.equipments;
      if (action.payload.dehuEquipments) state.dehuEquipments = action.payload.dehuEquipments;
    });
  },
});

export const masterActions = masterSlice.actions;

const masterReducer = masterSlice.reducer;
export default masterReducer;
